import React from 'react';
import {Navigate} from 'react-router-dom';
import {Alert, Box, Button, CircularProgress, Typography} from '@mui/material';
import {useAuth} from '../../providers/AuthProvider';
export default function ProtectedRoute({children}) {
    const {isAuthenticated, loading, error, refreshAuth} = useAuth();
    if (loading) return <Box role="status" sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, py: 10}}><CircularProgress size={22}/><Typography color="text.secondary">Getting things ready…</Typography></Box>;
    if (error) return <Alert severity="error" action={<Button color="inherit" onClick={() => void refreshAuth()}>Try again</Button>}>{error}</Alert>;
    if (!isAuthenticated) return <Navigate to="/login" replace/>;
    return children;
}
